<template>
      <div class="form-f" v-if="authFactors.indexOf('password')!=-1">
        <label>Lozinka:</label>
        <input type="password" class="form-field" v-model="authData.password" ref="passwordField" />
      </div>
</template>
<script>
export default {
  props: ["authData", "authFactors"],
  watch: {
    authFactors() {
      if (this.authFactors.indexOf('password')!=-1)
        this.$nextTick(()=>{
          this.$refs.passwordField?.focus();
        });
    },
  },
}
</script>
